<template>
    <slot></slot>
</template>
<script>
import EmailMixins from 'mixins/EmailMixins';
import Store from 'stores/overview/document/store';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('documentOverview');
export default {
    mixins: [EmailMixins],
    props: {
        ovtype: {
            type: String,
            default: '',
            required: false,
        },
        fileid: {
            type: String,
            default: '',
        },
        linkedid: {
            type: String,
            default: '',
        },
        linkedtype: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showTimeline:
                $('#' + this.ovtype + 'VerticalTab')
                    .find('.tab-v-menu li.current a')
                    .attr('id') === 'activity',
        };
    },
    computed: {
        ...mapState(['fileId', 'docFile']),
    },
    mounted() {
        EventBus.on('email:sendDocument', async () => {
            this.$store.dispatch('documentOverview/getDocFile');
            await this.checkEmailProvider(
                {
                    template: {
                        type: 'proposal',
                        contact: {
                            id: parseInt(this.linkedid),
                            type: 'proposal',
                        },
                        related: [
                            {
                                id: parseInt(this.linkedid),
                                type: 'proposal',
                            },
                        ],
                    },
                    related: [
                        {
                            id: this.linkedid,
                            type: 'proposal',
                        },
                    ],
                },
                { checkPrefill: true },
            );
        });
    },
    created() {
        this.$store.registerModule('documentOverview', Store);
        this.$store.commit('documentOverview/init', {
            fileId: this.fileid,
        });
    },
    unmounted() {
        EventBus.off('email:sendDocument');
    },
    methods: {
        refreshTimeline(status) {
            this.showTimeline = status;
            window.EventBus.emit('refreshTimeline');
        },
    },
};
</script>
